import React from 'react'
import * as  C from "../componentsM/index" 

const NationalRequirements = () => {
    return (
        <>

            <C.Hero title={"NATIONAL REQUIREMENTS"}
                image={"/hero/11.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>


                    <p>Pakistan Studies, Islamiyat and Urdu are compulsory for all Pakistani nationals, as per national requirements in order to attain equivalency in Pakistan. Urdu is taught in MYPs 1-5 in the Language Acquisition group, while Pakistan Studies and Islamiyat, taught in MYPs 3 and 4, are considered as subjects in the Individuals and Societies group. Although these subjects follow the IB MYP curriculum guidelines for teaching and assessment, the final exam for these three subjects, will be the CIE board given at the end of year 4. If a student wishes to be exempted from any of these subjects, the school bears no responsibility for the non-attainment of equivalency, needed for entry into Universities in Pakistan.</p>



                </div>
            </section>

        </>

    )
}

export default NationalRequirements